<template>
    <div id="app" class="app">
        <Header/>
        <router-view/>
    </div>
</template>

<script>
    import Header from "./components/Header";

    export default {
        components: {
            Header
        }
    }
</script>

<style lang="scss">
    html {
        font-family: "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
    }

    body, html {
        min-height: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }

    body {
        overflow-y: scroll;
        background: #242428;
    }

    .app {
        background: linear-gradient(to bottom, #3d3d43 0px, #242428 900px);
        display: grid;
        grid-template-columns: 1fr minmax(auto, 1000px) 1fr;
        grid-template-rows: auto 1fr auto 3fr;
        min-height: 100%;
        /*height: 100%;*/

        color: white;
        text-shadow: 1px 1px 1px black;
    }


</style>
